import PhaseFour from "components/Rater/CompleteSelfServey/SurveyPhase/PhaseFour"
import React from "react"

const PhaseFourPage = () => {
    return (
        <React.Fragment>
            <PhaseFour />
        </React.Fragment>
        
    )
}
export default PhaseFourPage
